import { fetchAreaList, fetchAccessAreaList } from '@/api/base/index';
import typeMapping from './typeMapping';

const GET_AREA_LIST = 'GET_AREA_LIST';
const FETCH_STATE = 'FETCH_STATE';
const FETCH_END = 'FETCH_END';

const state = () => {
  let areaState = {};
  typeMapping.map(type => {
    areaState[`list${type.value}`] = [];
    areaState[`fetching${type.value}`] = false;
  });
  return areaState;
};

const initGetters = () => {
  let getters = {};
  typeMapping.map(type => {
    getters[`areaList${type.value}`] = state => state[`list${type.value}`];
  });
  return getters;
};
const getters = initGetters();

const initAction = () => {
  let actions = {};
  typeMapping.map(type => {
    actions[`fetchAreaList${type.value}`] = ({ state, commit }) => {
      if (state[`fetching${type.value}`]) return;
      commit(FETCH_STATE, type.value);
      let fetchHandle = null;
      if (type.value == 0) {
        fetchHandle = fetchAreaList;
      } else {
        fetchHandle = fetchAccessAreaList;
      }
      return fetchHandle().then(res => {
        const list = res.data;
        commit(GET_AREA_LIST, { type: type.value, list });
        commit(FETCH_END, type.value);
      });
    };
  });
  return actions;
};
const actions = initAction();

const mutations = {
  [GET_AREA_LIST](state, { type, list }) {
    state[`list${type}`] = list;
  },
  [FETCH_STATE](state, type) {
    state[`fetching${type}`] = true;
  },
  [FETCH_END](state, type) {
    state[`fetching${type}`] = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
